import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { HOST } from 'config/config';
import tableDataQueryStringBuilder from 'services/Utilities/TableData';

const DEFAULT_TABLE_DATA = { pageSize: 0, currentPage: 0 };

const normalizeResponse = response => {
  if (Array.isArray(response?.data?.items)) {
    return response.data.items;
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  return [];
};

export const useMerchandisingProgramCategories = (tableDataParam = DEFAULT_TABLE_DATA) => {
  return useQuery({
    queryKey: ['merchandisingProgramCategories', JSON.stringify(tableDataParam)],
    queryFn: async () => {
      try {
        const response = await axios.get(`${HOST}/api/dealer-portal/merchandising-program-categories`, {
          paramsSerializer: params => tableDataQueryStringBuilder(params),
          params: tableDataParam,
        });

        return normalizeResponse(response);
      } catch {
        return [];
      }
    },
    staleTime: 0,
    retry: false,
  });
};
